export const BE03_TABLE_ID = "be03";

export const CMS_FIELDS = {
  IMAGE: "image",
  TITLE: "title",
  DESCRIPTION: "description",
  CATEGORY_TEXT: "categoryText",
} as const;

export const CMS_SECTION_FIELDS = {
  HEADING: "sectionHeading",
  SEE_ALL_TEXT: "sectionCtaText",
  SEE_ALL_URL: "sectionCtaLink",
  CARD: "card",
} as const;
